export default "__VITE_ASSET__e99e2d67__"